// Types
import {
    BANK_DETAILS_REQUEST_START,
    BANK_DETAILS_REQUEST_FAIL,
    BANK_DETAILS_REQUEST_SUCCESS,
    RETRIEVE_BANK_DETAILS_REQUEST_START,
    RETRIEVE_BANK_DETAILS_REQUEST_FAIL,
    RETRIEVE_BANK_DETAILS_REQUEST_SUCCESS,
    RESET_RETRIEVE_BANK_DETAILS,
    CREATE_BANK_DETAILS_REQUEST_START,
    CREATE_BANK_DETAILS_REQUEST_FAIL,
    CREATE_BANK_DETAILS_REQUEST_SUCCESS,
    GET_ALL_COUNTRY_DETAILS_REQUEST_START,
    GET_ALL_COUNTRY_DETAILS_REQUEST_FAIL,
    GET_ALL_COUNTRY_DETAILS_REQUEST_SUCCESS,
    GET_ALL_CURRENCY_DETAILS_REQUEST_FAIL,
    GET_ALL_CURRENCY_DETAILS_REQUEST_START,
    GET_ALL_CURRENCY_DETAILS_REQUEST_SUCCESS,
    BANK_DETAILS_V2_REQUEST_START,
    BANK_DETAILS_V2_REQUEST_FAIL,
    BANK_DETAILS_V2_REQUEST_SUCCESS,
    DELETE_BANK_DETAILS_REQUEST_START,
    DELETE_BANK_DETAILS_REQUEST_FAIL,
    DELETE_BANK_DETAILS_REQUEST_SUCCESS,
    RESET_DELETE_BANK_DETAILS,
    RESET_CREATE_BANK_DETAILS,
    ADD_BANK_DETAILS_DOCUMENT_REQUEST_START,
    ADD_BANK_DETAILS_DOCUMENT_REQUEST_FAIL,
    ADD_BANK_DETAILS_DOCUMENT_REQUEST_SUCCESS,
    RESET_ADD_BANK_DOCUMENT_DETAILS,
    FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_START,
    FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_FAIL,
    FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_SUCCESS
} from './types';
import { LoadingEvent } from '../../../core/types/GeneralTypes';
// Redux
import { BankDetailsAction } from './actions';

export type RetrieveBankDetailObjectType = {
    bank_name: string,
    account_number: string,
    address: string,
    country_code: string,
    national_id: string,
    recommended_bic: string,
    status: string,
};

type BankDetailsState = {
    bankDetails: object,
    loadingState: LoadingEvent,
    retrieveBankDetails: null | RetrieveBankDetailObjectType,
    retrieveLoadingState: LoadingEvent,
    createBankDetails: null | {},
    createLoadingState: LoadingEvent,
    getCountryDetails: null | {},
    getCountryDetailsLoadingState: LoadingEvent,
    getCurrencyDetails: null | {},
    getCurrencyDetailsLoadingState: LoadingEvent,
    bankDetailsV2: null | object,
    bankDetailsV2LoadingState: string,
    deleteBankDetailsLoadingState: LoadingEvent,
    bankDetailsDocUploadLoadingState: LoadingEvent,
    bankDetailsDocUploadResponse: null | object,
    organizationBankDetails: null | object,
    organizationBankDetailsLoadingState: LoadingEvent
};

const INITIAL_STATE: BankDetailsState = {
    bankDetails: {},
    loadingState: 'UNINITIALIZED',
    retrieveBankDetails: null,
    retrieveLoadingState: 'UNINITIALIZED',
    createBankDetails: null,
    createLoadingState: 'UNINITIALIZED',
    getCountryDetails: null,
    getCountryDetailsLoadingState: 'UNINITIALIZED',
    getCurrencyDetails: null,
    getCurrencyDetailsLoadingState: 'UNINITIALIZED',
    bankDetailsV2: null,
    bankDetailsV2LoadingState: 'UNINITIALISED',
    deleteBankDetailsLoadingState: 'UNINITIALIZED',
    bankDetailsDocUploadLoadingState: 'UNINITIALIZED',
    bankDetailsDocUploadResponse: null,
    organizationBankDetails: null,
    organizationBankDetailsLoadingState: 'UNINITIALIZED'
};

export const reducer = (
    state: BankDetailsState = INITIAL_STATE,
    action: BankDetailsAction
): BankDetailsState => {
    switch (action.type) {
        case BANK_DETAILS_REQUEST_START:
            return {
                ...state,
                loadingState: 'LOADING',
            };

        case BANK_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                loadingState: 'ERROR'
            };

        case BANK_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                loadingState: 'LOADED',
                bankDetails: action.payload,
            };

        case RETRIEVE_BANK_DETAILS_REQUEST_START:
            return {
                ...state,
                retrieveLoadingState: 'LOADING',
            };

        case RETRIEVE_BANK_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                retrieveLoadingState: 'ERROR'
            };

        case RETRIEVE_BANK_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                retrieveLoadingState: 'LOADED',
                retrieveBankDetails: action.payload?.bank_name ?  action.payload : null,
            };

        case RESET_RETRIEVE_BANK_DETAILS:
            return {
                ...state,
                retrieveLoadingState: 'UNINITIALIZED',
                retrieveBankDetails: null,
            };

        case CREATE_BANK_DETAILS_REQUEST_START:
            return {
                ...state,
                createLoadingState: 'LOADING',
            };

        case CREATE_BANK_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                createLoadingState: 'ERROR'
            };

        case CREATE_BANK_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                createLoadingState: 'SUCCESS',
                createBankDetails: action.payload,
            };

        case RESET_CREATE_BANK_DETAILS:
            return {
                ...state,
                createLoadingState: 'UNINITIALIZED',
                createBankDetails: null
            };

        case GET_ALL_COUNTRY_DETAILS_REQUEST_START:
            return {
                ...state,
                getCountryDetailsLoadingState: 'LOADING',
            };

        case GET_ALL_COUNTRY_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                getCountryDetailsLoadingState: 'ERROR'
            };

        case GET_ALL_COUNTRY_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                getCountryDetailsLoadingState: 'LOADED',
                getCountryDetails: action.payload,
            };

        case GET_ALL_CURRENCY_DETAILS_REQUEST_START:
            return {
                ...state,
                getCurrencyDetailsLoadingState: 'LOADING',
            };

        case GET_ALL_CURRENCY_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                getCurrencyDetailsLoadingState: 'ERROR'
            };

        case GET_ALL_CURRENCY_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                getCurrencyDetailsLoadingState: 'LOADED',
                getCurrencyDetails: action.payload,
            };

        case BANK_DETAILS_V2_REQUEST_START:
            return {
                ...state,
                bankDetailsV2LoadingState: 'LOADING'
            };

        case BANK_DETAILS_V2_REQUEST_FAIL:
            return {
                ...state,
                bankDetailsV2LoadingState: 'ERROR'
            };

        case BANK_DETAILS_V2_REQUEST_SUCCESS:
            return {
                ...state,
                bankDetailsV2LoadingState: 'LOADED',
                bankDetailsV2: action.payload,
            };

        case DELETE_BANK_DETAILS_REQUEST_START:
            return {
                ...state,
                deleteBankDetailsLoadingState: 'LOADING'
            };

        case DELETE_BANK_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                deleteBankDetailsLoadingState: 'ERROR'
            };

        case DELETE_BANK_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                deleteBankDetailsLoadingState: 'SUCCESS'
            };

        case RESET_DELETE_BANK_DETAILS:
            return {
                ...state,
                deleteBankDetailsLoadingState: 'UNINITIALIZED'
            };

        case ADD_BANK_DETAILS_DOCUMENT_REQUEST_START:
            return {
                ...state,
                bankDetailsDocUploadLoadingState: 'LOADING'
            };

        case ADD_BANK_DETAILS_DOCUMENT_REQUEST_FAIL:
            return {
                ...state,
                bankDetailsDocUploadLoadingState: 'ERROR'
            };

        case ADD_BANK_DETAILS_DOCUMENT_REQUEST_SUCCESS:
            return {
                ...state,
                bankDetailsDocUploadLoadingState: 'SUCCESS',
                bankDetailsDocUploadResponse: action.payload
            };

        case RESET_ADD_BANK_DOCUMENT_DETAILS:
            return {
                ...state,
                bankDetailsDocUploadLoadingState: 'UNINITIALIZED'
            };

        case FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_START:
            return {
                ...state,
                organizationBankDetailsLoadingState: 'LOADING'
            };

        case FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_FAIL:
            return {
                ...state,
                organizationBankDetailsLoadingState: 'ERROR'
            };

        case FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                organizationBankDetailsLoadingState: 'SUCCESS',
                organizationBankDetails: action.payload
            };

        default:
            return state;
    }
};